import bulkNotifications from "@/modules/core/bulk-notifications/store";

// common
import grid from '@/modules/common/store/gridEntities';
import paths from '@/modules/core/common/store/paths';

export default {
    core: {
        namespaced: true,
        modules: {
            bulkNotifications: bulkNotifications
        }
    },
    common: {
        namespaced: true,
        modules: {
            grid: grid,
            paths: paths
        }
    }
};
